import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { OverlayProvider } from 'overlay-kit';

const container = document.getElementById('root') as HTMLElement;
const app = (
	<HelmetProvider>
		<BrowserRouter basename="/">
			<OverlayProvider>
				<App />
			</OverlayProvider>
		</BrowserRouter>
	</HelmetProvider>
);
if (container.dataset.prerendered) ReactDOM.hydrateRoot(container, app);
else ReactDOM.createRoot(container).render(app);
